import { render } from "./information.vue?vue&type=template&id=e0c75f32&scoped=true&ts=true"
import script from "./information.vue?vue&type=script&lang=ts"
export * from "./information.vue?vue&type=script&lang=ts"

import "./information.vue?vue&type=style&index=0&id=e0c75f32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0c75f32"]])

export default __exports__